import { render } from "./ContentInfoComponent.vue?vue&type=template&id=2fa923c5"
import script from "./ContentInfoComponent.vue?vue&type=script&lang=js"
export * from "./ContentInfoComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__